import type {
  BirdEyeFinishedPatient,
  BirdEyeFinishedSummary,
  BirdEyeOperatory,
  BirdEyePatient,
} from './types';

// Bird-eye board state is sourced from /api/bird-eye; no mock seed.
export const BEV_NOW = '';

export const BEV_ARRIVING: BirdEyePatient[] = [];

export const BEV_WAITING: BirdEyePatient[] = [];

export const BEV_OPS: BirdEyeOperatory[] = [];

export const BEV_WALKING: BirdEyePatient[] = [];

export const BEV_FINISHED: BirdEyeFinishedSummary = {
  total: 0,
  production: 0,
  firstTime: '',
  lastTime: '',
};

export const BEV_FINISHED_LIST: BirdEyeFinishedPatient[] = [];
